<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-02-02 10:07:19
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-27 17:02:28
 * @FilePath: \esmcc-front\src\components\common\es-org-tree.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div :style="{ 'overflow': 'auto', 'height': height }"
       v-loading="isLoading">
    <el-tree default-expand-all
             :check-strictly="checkstrictly == null ? true : checkstrictly"
             show-checkbox
             :default-checked-keys="checkedKeys == null ? [] : checkedKeys"
             :expand-on-click-node="false"
             ref="orgTree"
             node-key="id"
             @check="checkChange"
             :data="orgTree"
             class="org_tree_class"></el-tree>
  </div>
</template>

<script>
export default {
  name: 'esOrgTree',
  props: ['height', 'checkedKeys', 'isAll', 'checkstrictly'],
  data () {
    return {
      orgTree: [],
      isLoading: false
    }
  },
  methods: {
    checkChange (ele, checks) {
      this.$emit('clickByOrg', checks.checkedKeys)
    },
    //加载组织树
    load_orgTree () {
      this.isLoading = true
      //checkstrictly是false时，父节点不需要设置disabled
      this.$ajax.get('/base/org/list_common', { isAll: this.isAll, checkstrictly: this.checkstrictly == null ? true : this.checkstrictly, orderBy: 'sortnum' }).then(msg => {
        this.orgTree = msg
        console.log(msg)
        this.$emit('completed', msg)
        this.isLoading = false
      }).catch(err => {
        this.$message.error(err)
        this.isLoading = false
      })
    },
  },
  mounted () {
    this.load_orgTree()
  }
}
</script>

<style scoped>
.org_tree_class {
  min-width: 210px;
}
</style>